<template>
  <div></div>
</template>

<script>
export default {
  name: "ProtectDeviceManagementWebsocket",
  props: {},
  data() {
    return {
      webSocketBase: "/fire/control/news",
      webSocketIp: "",
      lockReconnect: false, //避免ws重复连接
      webSocket: null, // 判断当前浏览器是否支持WebSocket
      heartCheck: {
        timeout: 5000, //1分钟发一次心跳
        timeoutObj: null,
        serverTimeoutObj: null
      },
      reconnectTimer: null,
      isLeave: false
    };
  },
  created() {
    // let schoolId = this.$store.state.schoolId || 0;
    // let param = "?schoolId=" + schoolId;
    // this.webSocketIp =
    //   this.$store.state.config.wsIpConfig + this.webSocketBase + param;

    // this.createWebSocket();

    // window.addEventListener("beforeunload", () => {
    //   if (this.webSocket) {
    //     this.webSocket.close();
    //     clearTimeout(this.reconnectTimer);
    //   }
    // });
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    // 创建 webSockert
    createWebSocket() {
      try {
        if ("WebSocket" in window) {
          // console.log(this.webSocketIp)
          this.webSocket = new WebSocket(this.webSocketIp);
        }
        this.initEventHandle();
      } catch (e) {
        this.reconnect(this.webSocketIp);
        // console.log(e);
      }
    },
    // 连接 webSocket 成功、收到消息、断开等方法
    initEventHandle() {
      this.webSocket.onclose = (e) => {
        // console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
        console.log("ws连接关闭!" + new Date().toLocaleString());
        if (!this.isLeave) {
          this.reconnect(this.webSocketIp);
        }
      };
      this.webSocket.onerror = () => {
        this.reconnect(this.webSocketIp);
        // console.log("ws连接错误!");
      };
      this.webSocket.onopen = () => {
        this.reset(); //心跳检测重置
        this.start(); //心跳检测开始
        console.log("ws连接成功!" + new Date().toLocaleString());
      };
      this.webSocket.onmessage = (event) => {
        //如果获取到消息，心跳检测重置
        this.reset();
        //拿到任何消息都说明当前连接是正常的
        // console.log("ws收到消息啦:" + event.data);
        if (event.data != "连接成功") {
          this.$notify.error({
            title: "警告",
            message: event.data,
            duration: 0
          });
        }
      };
    },
    // 重新连接 webSocket
    reconnect(url) {
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      this.reconnectTimer = setTimeout(() => {
        //没连接上会一直重连，设置延迟避免请求过多
        this.createWebSocket(url);
      }, 2000);
    },
    // 重置心跳检测
    reset() {
      clearTimeout(this.heartCheck.timeoutObj);
      clearTimeout(this.heartCheck.serverTimeoutObj);
    },
    // 开始心跳检测
    start() {
      this.heartCheck.timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常

        this.webSocket.send("ping");
        // console.log("ping!")

        this.heartCheck.serverTimeoutObj = setTimeout(() => {
          //如果超过一定时间还没重置，说明后端主动断开了
          this.webSocket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
        }, this.heartCheck.timeout);
      }, this.heartCheck.timeout);
    }
  },
  destroyed() {
    if (this.webSocket) {
      this.isLeave = true;
      this.webSocket.close();
    }
    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = () => {
      this.webSocket.close();
      clearTimeout(this.reconnectTimer);
    };
  }
};
</script>

<style lang="scss" scoped></style>
